const API_VER = 'v2.0'
export const DMSEndpoints = {
    DMS_DEVICE_URI: `/dms/api/${API_VER}/devices/`,
    DMS_DEVICE_PERSON_URI: `/dms/api/${API_VER}/devices/persons/`,
}
